export type IUserGender = 'Male' | 'Female';

export interface UserModel {
  address: string;
  avatar: string;
  description: string;
  dateOfBirth: string;
  school: string;
  email: string;
  gender: IUserGender;
  name: string;
  username: string;
  contacts: IContact[];
}

export interface IContact {
  phone: string;
  isMainContact: boolean;
  description?: string;
}

export interface IUser extends UserModel {
  id: number;
  isDeleted: boolean;
  role: string;
}

export const HPRole = {
  Admin: 'Admin',
  Employee: 'Employee',
  Parent: 'Parent',
  Student: 'Student',
  TA: 'TA',
  Teacher: 'Teacher',
};

export const HPRoleList = Object.values(HPRole);
